module.exports = __webpack_public_path__ + "img/icon6.53e4fca3.png";